webpackJsonp([218538773642512],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(82);

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(59);

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(60);

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(83);

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(84);

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85);

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(61);

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(62);

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63);

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(64);

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithoutHoles;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var _Object$defineProperty = __webpack_require__(34);
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	
	    _Object$defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	var _Object$assign = __webpack_require__(32);
	
	function _extends() {
	  module.exports = _extends = _Object$assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	var _Object$setPrototypeOf = __webpack_require__(37);
	
	var _Object$create = __webpack_require__(33);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	module.exports = _inherits;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var _getIterator = __webpack_require__(10);
	
	function _iterableToArrayLimit(arr, i) {
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}
	
	module.exports = _nonIterableRest;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var _Object$getOwnPropertySymbols = __webpack_require__(35);
	
	var _Object$keys = __webpack_require__(8);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	
	  var sourceKeys = _Object$keys(source);
	
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (_Object$getOwnPropertySymbols) {
	    var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(16);
	
	var assertThisInitialized = __webpack_require__(11);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(40);
	
	var iterableToArrayLimit = __webpack_require__(42);
	
	var nonIterableRest = __webpack_require__(43);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var _Symbol$iterator = __webpack_require__(39);
	
	var _Symbol = __webpack_require__(38);
	
	function _typeof2(obj) { if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof _Symbol === "function" && _typeof2(_Symbol$iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var d=d||{};d.scope={};d.ASSUME_ES5=!1;d.ASSUME_NO_NATIVE_MAP=!1;d.ASSUME_NO_NATIVE_SET=!1;d.defineProperty=d.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,c,e){a!=Array.prototype&&a!=Object.prototype&&(a[c]=e.value)};d.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};d.global=d.getGlobal(this);d.SYMBOL_PREFIX="jscomp_symbol_";
	d.initSymbol=function(){d.initSymbol=function(){};d.global.Symbol||(d.global.Symbol=d.Symbol)};d.Symbol=function(){var a=0;return function(c){return d.SYMBOL_PREFIX+(c||"")+a++}}();d.initSymbolIterator=function(){d.initSymbol();var a=d.global.Symbol.iterator;a||(a=d.global.Symbol.iterator=d.global.Symbol("iterator"));"function"!=typeof Array.prototype[a]&&d.defineProperty(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return d.arrayIterator(this)}});d.initSymbolIterator=function(){}};
	d.arrayIterator=function(a){var c=0;return d.iteratorPrototype(function(){return c<a.length?{done:!1,value:a[c++]}:{done:!0}})};d.iteratorPrototype=function(a){d.initSymbolIterator();a={next:a};a[d.global.Symbol.iterator]=function(){return this};return a};
	d.iteratorFromArray=function(a,c){d.initSymbolIterator();a instanceof String&&(a+="");var e=0,b={next:function(){if(e<a.length){var f=e++;return{value:c(f,a[f]),done:!1}}b.next=function(){return{done:!0,value:void 0}};return b.next()}};b[Symbol.iterator]=function(){return b};return b};
	d.polyfill=function(a,c){if(c){var e=d.global;a=a.split(".");for(var b=0;b<a.length-1;b++){var f=a[b];f in e||(e[f]={});e=e[f]}a=a[a.length-1];b=e[a];c=c(b);c!=b&&null!=c&&d.defineProperty(e,a,{configurable:!0,writable:!0,value:c})}};d.polyfill("Array.prototype.values",function(a){return a?a:function(){return d.iteratorFromArray(this,function(a,e){return e})}},"es8","es3");Object.defineProperty(exports,"__esModule",{value:!0});
	var g=__webpack_require__(15),h=__webpack_require__(14),k=__webpack_require__(8),l=__webpack_require__(16),m=__webpack_require__(12),n=__webpack_require__(13);function p(a){var c=new Intl.DateTimeFormat(a,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{});return function(a){return c.format(a)}}
	function q(a){var c=new Intl.NumberFormat(a,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{});return function(a){return c.format(a)}}
	function r(a){function c(a,c){return function(b){b="function"===typeof c?c(b):c;return(Array.isArray(b)?b:[b]).map(function(c){return"string"===typeof c?c.replace("#",a):c})}}function e(a){return"string"===typeof a?b[a]||{style:a}:a}var b=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},f=(1<arguments.length&&void 0!==arguments[1]?arguments[1]:{}).plurals;return{plural:function(a,b){var e=b.offset;e=void 0===e?0:e;b=g(b,["offset"]);b=b[a]||b[f(a-e)];return c(a-e,b)},selectordinal:function(a,
	b){var e=b.offset;e=void 0===e?0:e;b=g(b,["offset"]);b=b[a]||b[f(a-e,!0)];return c(a-e,b)},select:function(a,c){return c[a]||c.other},number:function(c,b){return q(a,e(b))(c)},date:function(c,b){return p(a,e(b))(c)},undefined:function(a){return a}}}function t(a){var c=a.values,e=r(a.language,a.languageData,a.formats);return function w(a,u,v){a=e[u](c[a],v);a="function"===typeof a?a(w):a;return Array.isArray(a)?a.join(""):a}}
	function x(a,c,e){return function(b){var f=a(t({language:c,languageData:e,formats:1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},values:b}));return Array.isArray(f)?f.join("").trim():f}}
	var z=function(){function a(){m(this,a);Object.defineProperty(this,"_language",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"_catalogs",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"_activeMessages",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"_activeLanguageData",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"_dev",{configurable:!0,enumerable:!0,
	writable:!0,value:void 0});Object.defineProperty(this,"t",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"plural",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"select",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(this,"selectOrdinal",{configurable:!0,enumerable:!0,writable:!0,value:void 0});this._activeMessages={};this._catalogs={}}n(a,[{key:"_cacheActiveLanguage",value:function(){var a=
	this._catalogs[this.language],e=(a||{}).languageData||{};this._activeMessages=(a||{}).messages||{};this._activeLanguageData=e}},{key:"load",value:function(a){var c=this;"object"===l(a)&&(k(h({},this._catalogs,a)).forEach(function(b){c._catalogs[b]={messages:h({},(c._catalogs[b]||{}).messages||{},(a[b]||{}).messages||{}),languageData:h({},(c._catalogs[b]||{}).languageData||{},(a[b]||{}).languageData||{})}}),this._cacheActiveLanguage())}},{key:"activate",value:function(a){a&&(this._language=a,this._cacheActiveLanguage())}},
	{key:"use",value:function(a){return y({language:a,catalogs:this._catalogs,development:this._dev})}},{key:"_",value:function(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},b=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},f=b.defaults;b=b.formats;b=void 0===b?{}:b;f=this.messages[a]||f||a;return"function"!==typeof f?f:x(f,this.language,this.languageData)(c,b)}},{key:"pluralForm",value:function(a){return this.languageData.plurals?this.languageData.plurals(a,"ordinal"===
	(1<arguments.length&&void 0!==arguments[1]?arguments[1]:"cardinal")):"other"}},{key:"availableLanguages",get:function(){return k(this._catalogs)}},{key:"language",get:function(){return this._language}},{key:"messages",get:function(){return this._activeMessages}},{key:"languageData",get:function(){return this._activeLanguageData}}]);return a}();
	function y(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},c=new z;a.catalogs&&c.load(a.catalogs);a.language&&c.activate(a.language);return c}var A=y();exports.i18nMark=function(a){return a};exports.i18n=A;exports.setupI18n=y;exports.date=p;exports.number=q;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(46)
	} else {
	  module.exports = require("./cjs/core.development.js")
	}


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var f=f||{};f.scope={};f.ASSUME_ES5=!1;f.ASSUME_NO_NATIVE_MAP=!1;f.ASSUME_NO_NATIVE_SET=!1;f.defineProperty=f.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,c,b){a!=Array.prototype&&a!=Object.prototype&&(a[c]=b.value)};f.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};f.global=f.getGlobal(this);f.SYMBOL_PREFIX="jscomp_symbol_";
	f.initSymbol=function(){f.initSymbol=function(){};f.global.Symbol||(f.global.Symbol=f.Symbol)};f.Symbol=function(){var a=0;return function(c){return f.SYMBOL_PREFIX+(c||"")+a++}}();f.initSymbolIterator=function(){f.initSymbol();var a=f.global.Symbol.iterator;a||(a=f.global.Symbol.iterator=f.global.Symbol("iterator"));"function"!=typeof Array.prototype[a]&&f.defineProperty(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return f.arrayIterator(this)}});f.initSymbolIterator=function(){}};
	f.arrayIterator=function(a){var c=0;return f.iteratorPrototype(function(){return c<a.length?{done:!1,value:a[c++]}:{done:!0}})};f.iteratorPrototype=function(a){f.initSymbolIterator();a={next:a};a[f.global.Symbol.iterator]=function(){return this};return a};
	f.iteratorFromArray=function(a,c){f.initSymbolIterator();a instanceof String&&(a+="");var b=0,e={next:function(){if(b<a.length){var d=b++;return{value:c(d,a[d]),done:!1}}e.next=function(){return{done:!0,value:void 0}};return e.next()}};e[Symbol.iterator]=function(){return e};return e};
	f.polyfill=function(a,c){if(c){var b=f.global;a=a.split(".");for(var e=0;e<a.length-1;e++){var d=a[e];d in b||(b[d]={});b=b[d]}a=a[a.length-1];e=b[a];c=c(e);c!=e&&null!=c&&f.defineProperty(b,a,{configurable:!0,writable:!0,value:c})}};f.polyfill("Array.prototype.values",function(a){return a?a:function(){return f.iteratorFromArray(this,function(a,b){return b})}},"es8","es3");Object.defineProperty(exports,"__esModule",{value:!0});
	var l=__webpack_require__(36),m=__webpack_require__(12),n=__webpack_require__(13),p=__webpack_require__(44),r=__webpack_require__(41),t=__webpack_require__(11),u=__webpack_require__(1),v=__webpack_require__(2),w=__webpack_require__(14),x=__webpack_require__(56),z=__webpack_require__(47),B=__webpack_require__(10),
	C=__webpack_require__(45),D=__webpack_require__(8),E=__webpack_require__(15),F=function(a){function c(){var b,a,d;m(this,c);for(var g=arguments.length,h=Array(g),k=0;k<g;k++)h[k]=arguments[k];return p(d,(a=d=p(this,(b=c.__proto__||l(c)).call.apply(b,[this].concat(h))),Object.defineProperty(t(d),"props",{configurable:!0,enumerable:!0,writable:!0,value:void 0}),a))}r(c,a);n(c,[{key:"render",value:function(){var b=this.props,
	a=b.className;b=b.value;var c=this.props.render||this.context.linguiDefaultRender;return null===c||void 0===c?b:"string"===typeof c?u.createElement(c,{className:a},b):u.isValidElement(c)?u.cloneElement(c,{},b):u.createElement(c,{translation:b})}}]);return c}(u.Component);Object.defineProperty(F,"contextTypes",{configurable:!0,enumerable:!0,writable:!0,value:{linguiDefaultRender:v.any}});
	function J(a){return function(c){var b=c.value,e=c.className,d=c.render;c=a(c.i18n.language,c.format);return u.createElement(F,{className:e,render:d,value:c(b)})}}
	function K(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return function(c){var b=a.update,e=void 0===b?!0:b;b=a.withHash;var d=void 0===b?!0:b;b=a.withRef;var g=void 0===b?!1:b;b=function(b){function a(){var b,c,e;m(this,a);for(var d=arguments.length,k=Array(d),h=0;h<d;h++)k[h]=arguments[h];return p(e,(c=e=p(this,(b=a.__proto__||l(a)).call.apply(b,[this].concat(k))),Object.defineProperty(t(e),"wrappedInstance",{configurable:!0,enumerable:!0,writable:!0,value:null}),Object.defineProperty(t(e),
	"setWrappedInstance",{configurable:!0,enumerable:!0,writable:!0,value:function(b){g&&(e.wrappedInstance=b)}}),Object.defineProperty(t(e),"getWrappedInstance",{configurable:!0,enumerable:!0,writable:!0,value:function(){if(!g)throw Error("To access the wrapped instance, you need to specify { withRef: true } in the options argument of the withI18n() call.");return e.wrappedInstance}}),Object.defineProperty(t(e),"checkUpdate",{configurable:!0,enumerable:!0,writable:!0,value:function(){e.forceUpdate()}}),
	c))}r(a,b);n(a,[{key:"componentDidMount",value:function(){var b=this.getI18n().subscribe;e&&b&&b(this.checkUpdate)}},{key:"componentWillUnmount",value:function(){var b=this.getI18n().unsubscribe;e&&b&&b(this.checkUpdate)}},{key:"getI18n",value:function(){return this.context.linguiPublisher||{}}},{key:"render",value:function(){var b=this.getI18n(),a=b.i18n;b=b.i18nHash;b=w({},this.props,g?{ref:this.setWrappedInstance}:{},d?{i18nHash:b}:{});return u.createElement(c,w({},b,{i18n:a}))}}]);return a}(u.Component);
	Object.defineProperty(b,"contextTypes",{configurable:!0,enumerable:!0,writable:!0,value:{linguiPublisher:v.object}});return b}}
	function L(a){var c=[];return{i18n:a,i18nHash:null,getSubscribers:function(){return c},subscribe:function(b){c.push(b)},unsubscribe:function(b){c=c.filter(function(a){return a!==b})},update:function(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},e=b.catalogs;b=b.language;if(e||b)e&&a.load(e),b&&a.activate(b),this.i18nHash=x([a.language,a.messages]),c.forEach(function(b){return b()})}}}
	var M=function(a){function c(b){m(this,c);var a=p(this,(c.__proto__||l(c)).call(this,b));Object.defineProperty(t(a),"props",{configurable:!0,enumerable:!0,writable:!0,value:void 0});Object.defineProperty(t(a),"linguiPublisher",{configurable:!0,enumerable:!0,writable:!0,value:void 0});var d=b.language,g=b.catalogs;b=b.i18n||z.setupI18n({language:d,catalogs:g});a.linguiPublisher=new L(b);return a}r(c,a);n(c,[{key:"componentDidUpdate",value:function(b){var a=this.props,c=a.language;a=a.catalogs;c===
	b.language&&a===b.catalogs||this.linguiPublisher.update({language:c,catalogs:a})}},{key:"getChildContext",value:function(){return{linguiPublisher:this.linguiPublisher,linguiDefaultRender:this.props.defaultRender}}},{key:"render",value:function(){return u.createElement(u.Fragment,null,this.props.children)}}]);return c}(u.Component);Object.defineProperty(M,"defaultProps",{configurable:!0,enumerable:!0,writable:!0,value:{defaultRender:null}});
	Object.defineProperty(M,"childContextTypes",{configurable:!0,enumerable:!0,writable:!0,value:{linguiPublisher:v.object.isRequired,linguiDefaultRender:v.any}});var N=/<(\d+)>(.*)<\/\1>|<(\d+)\/>/,O=/(?:\r\n|\r|\n)/g;
	function P(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:[],b=a.replace(O,"").split(N);if(1===b.length)return a;var e=[],d=b.shift();d&&e.push(d);d=!0;var g=!1,h=void 0;try{for(var k=B(Q(b)),G;!(d=(G=k.next()).done);d=!0){var A=C(G.value,3),H=A[0],I=A[1],q=A[2];e.push(u.cloneElement(c[H],{key:H},I?P(I,c):null));q&&e.push(q)}}catch(y){g=!0,h=y}finally{try{d||null==k.return||k.return()}finally{if(g)throw h;}}return e}
	function Q(a){if(!a.length)return[];var c=a.slice(0,4);c=C(c,4);var b=c[1],e=c[2],d=c[3];return[[parseInt(c[0]||e),b||"",d]].concat(Q(a.slice(4,a.length)))}
	var R=function(a){function c(){var b,a,d;m(this,c);for(var g=arguments.length,h=Array(g),k=0;k<g;k++)h[k]=arguments[k];return p(d,(a=d=p(this,(b=c.__proto__||l(c)).call.apply(b,[this].concat(h))),Object.defineProperty(t(d),"props",{configurable:!0,enumerable:!0,writable:!0,value:void 0}),a))}r(c,a);n(c,[{key:"componentDidMount",value:function(){}},{key:"getTranslation",value:function(){var b=this.props,a=b.id;a=void 0===a?"":a;var c=b.defaults,g=b.i18n,h=b.values;b=b.formats;return g&&"function"===
	typeof g._?g._(a,h,{defaults:c,formats:b}):a}},{key:"render",value:function(){var b=P(this.getTranslation(),this.props.components);return u.createElement(F,{render:this.props.render,className:this.props.className,value:b})}}]);return c}(u.Component),S=K()(R),T=K()(function(a){function c(){var b,a,d;m(this,c);for(var g=arguments.length,h=Array(g),k=0;k<g;k++)h[k]=arguments[k];return p(d,(a=d=p(this,(b=c.__proto__||l(c)).call.apply(b,[this].concat(h))),Object.defineProperty(t(d),"props",{configurable:!0,
	enumerable:!0,writable:!0,value:void 0}),a))}r(c,a);n(c,[{key:"render",value:function(){var a=this.props,c=a.className,d=a.render,g=a.i18n;a=E(a,["className","render","i18n"]);return u.createElement(F,{className:c,render:d,value:g.select(a)})}}]);return c}(u.Component));
	function U(){var a,c,b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:!1,e=b?"SelectOrdinal":"Plural",d=b?"selectOrdinal":"plural";return c=a=function(a){function b(){var a,c,d;m(this,b);for(var g=arguments.length,h=Array(g),q=0;q<g;q++)h[q]=arguments[q];return p(d,(c=d=p(this,(a=b.__proto__||l(b)).call.apply(a,[this].concat(h))),Object.defineProperty(t(d),"displayName",{configurable:!0,enumerable:!0,writable:!0,value:e}),Object.defineProperty(t(d),"props",{configurable:!0,enumerable:!0,writable:!0,
	value:void 0}),c))}r(b,a);n(b,[{key:"render",value:function(){var a=this.props,b=a.className,c=a.render,e=a.i18n,g=a.value,h=a.offset,y=E(a,["className","render","i18n","value","offset"]);a=D(y).reduce(function(a,b){var c=b.replace("_","");a[c]=y[b];return a},{value:parseInt(g),offset:parseInt(h)});return u.createElement(F,{className:b,render:c,value:e[d](a)})}}]);return b}(u.Component),Object.defineProperty(a,"defaultProps",{configurable:!0,enumerable:!0,writable:!0,value:{offset:0}}),c}
	var V=K()(U(!1)),W=K()(U(!0)),X=K()(J(z.date)),Y=K()(J(z.number));exports.withI18n=K;exports.DateFormat=X;exports.NumberFormat=Y;exports.i18nMark=function(a){return a};exports.I18nProvider=M;exports.Trans=S;exports.Plural=V;exports.Select=T;exports.SelectOrdinal=W;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(48)
	} else {
	  module.exports = require("./cjs/react.development.js")
	}


/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	'use strict';
	
	function pad (hash, len) {
	  while (hash.length < len) {
	    hash = '0' + hash;
	  }
	  return hash;
	}
	
	function fold (hash, text) {
	  var i;
	  var chr;
	  var len;
	  if (text.length === 0) {
	    return hash;
	  }
	  for (i = 0, len = text.length; i < len; i++) {
	    chr = text.charCodeAt(i);
	    hash = ((hash << 5) - hash) + chr;
	    hash |= 0;
	  }
	  return hash < 0 ? hash * -2 : hash;
	}
	
	function foldObject (hash, o, seen) {
	  return Object.keys(o).sort().reduce(foldKey, hash);
	  function foldKey (hash, key) {
	    return foldValue(hash, o[key], key, seen);
	  }
	}
	
	function foldValue (input, value, key, seen) {
	  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
	  if (value === null) {
	    return fold(hash, 'null');
	  }
	  if (value === undefined) {
	    return fold(hash, 'undefined');
	  }
	  if (typeof value === 'object') {
	    if (seen.indexOf(value) !== -1) {
	      return fold(hash, '[Circular]' + key);
	    }
	    seen.push(value);
	    return foldObject(hash, value, seen);
	  }
	  return fold(hash, value.toString());
	}
	
	function toString (o) {
	  return Object.prototype.toString.call(o);
	}
	
	function sum (o) {
	  return pad(foldValue(0, o, '', []).toString(16), 8);
	}
	
	module.exports = sum;


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(76);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react3 = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage(_ref) {
	  var i18n = _ref.i18n;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      _react2.default.createElement(_react3.Trans, {
	        id: 'Hi from the second page'
	      })
	    ),
	    _react2.default.createElement(_react3.Trans, { id: 'welcome-page-2', render: 'p' }),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: i18n._('/') },
	      _react2.default.createElement(_react3.Trans, {
	        id: 'Go back to the homepage'
	      })
	    )
	  );
	};
	
	exports.default = (0, _react3.withI18n)()(SecondPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-page-2-js-ac078d5e3ec7e771ec81.js